import { render } from "./SalesTraining.vue?vue&type=template&id=75b1cfae"
import script from "./SalesTraining.vue?vue&type=script&lang=js"
export * from "./SalesTraining.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__